import styled from 'styled-components';

export const Wrapper = styled.div`
  height: calc(100% - 60px);
  position: fixed;
  right: 60px;
  top: 60px;
  width: 500px;
  z-index: 2000;
  background: ${props => props.theme.themeColors.controlBar.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
  @media all and (max-width: 1200px) {
    width: calc(50% - 60px);
  }
`;


export const StyledHeader = styled.div`
  align-items: center;
  background: ${({ theme }) =>
    theme.themeColors.sidebars.bookmarks.headerBackground};
  border-radius: 3px;
  display: flex;
  margin-bottom: 1.5rem;
  min-height: 40px;
  position: relative;
  padding: 0 0 0 .5rem; 
  overflow: hidden;
  justify-content: space-between;
`;

export const StyledBodyLoad = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props =>
  props.active
    ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
    : props.theme.themeColors.sidebars.thumbnails.textColor};
  height: calc(100% - 40px);
  overflow-y: auto;
`;

export const BtnBlock = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

export const CloseBtn = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  width: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > svg {
    height: 30px;
    width: 30px;
  }
  &:hover {
    background: rgba(0,0,0,.1);
  }
`;

export const SaveBtn = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  width: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > svg {
    height: 25px;
    width: 25px;
  }
  &:hover {
    background: rgba(0,0,0,.1);
  }
`;

export const DownloadBtn = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  width: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > svg {
    height: 20px;
    width: 20px;
  }
  &:hover {
    background: rgba(0,0,0,.1);
  }
`;

export const AiBtn = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  width: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > svg {
    height: 20px;
    width: 20px;
  }
  &:hover {
    background: rgba(0,0,0,.1);
  }
`;

export const TitleInput = styled.input`
  background: transparent;
  border: 1px solid transparent;
  outline: none;
  padding: .4rem .5rem;
  border-radius: 3px;
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:focus, &:hover {
    border: 1px solid #000000;
    background: #ffffff;
    white-space: normal;
  }
`;

export const StyledQuill = styled.div`
  width: 100%;
  backgroundColor: #ffffff;
  height: calc(100% - 66px);
  & p {
    margin-bottom: 10px;
  }
`;